import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const Seo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
  }, [title, description]);
  return null;
};

export default Seo;
